export default {
  getGrantApplications: (state) => state.grantApplications,
};
